export default Object.freeze({
	supplier: 'Distribuidor SHIELD',
	general: 'Público General',
	maquila: 'Maquila',
})
